import { excess } from './excess';

export const programmatic = {
  excess,
};
